import { services } from '../content/site';
import SectionHeading from './SectionHeading';

export default function Services() {
  return (
    <section id="services" className="bg-cream-alt py-24">
      <div className="container-page">
        <SectionHeading eyebrow={services.eyebrow} heading={services.heading} align="center" />

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.items.map((item, i) => (
            <article
              key={item.title}
              className="rounded-xl2 border border-ink/5 bg-cream p-6 shadow-soft transition-transform hover:-translate-y-1"
            >
              <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-coral/10 font-display text-coral">
                {i + 1}
              </div>
              <h3 className="text-lg font-display text-ink">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-soft">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
